module.exports = __webpack_public_path__ + "media/images/amanata-915c4047215dc256a5ab568a975630c6.png";